import axiosGraphQL from './GraphQL/axiosGraphQL';
import { VARIABLES_GET_STATUS_SALE_PLANNING } from './GraphQL/Queries/codeQuery';
import {
  QUERY_GET_LOCATION_CUSTOMER_BY_TEAM_SALE,
  QUERY_GET_STATUS_SALE_PLANNING,
  QUERY_ROUTE_TRACKING_GET_LOCATION_TEAM_SALE,
  QUERY_ROUTE_TRACKING_GET_TEAM_SALE,
} from './GraphQL/Queries/routeTrackingQuery';
import {
  VARIABLES_GET_LOCATION_CUSTOMER_BY_TEAM_SALE,
  VARIABLES_ROUTE_TRACKING_GET_LOCATION_TEAM_SALE,
  VARIABLES_ROUTE_TRACKING_GET_TEAM_SALE,
} from './GraphQL/Variables/routeTracking';

export const RouteTrackingApi = {
  getTeamSaleByFilter: async (filter: any) => {
    const { page, page_size } = filter;
    return await axiosGraphQL.post('/graphql', {
      query: QUERY_ROUTE_TRACKING_GET_TEAM_SALE,
      variables: VARIABLES_ROUTE_TRACKING_GET_TEAM_SALE(filter),
    });
  },

  getLocationTeamSaleByPlant: async (filter: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: QUERY_ROUTE_TRACKING_GET_LOCATION_TEAM_SALE,
      variables: VARIABLES_ROUTE_TRACKING_GET_LOCATION_TEAM_SALE(filter),
    });
  },

  getLocationTeamSaleInPlantByTeamSale: async (filter: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: QUERY_GET_LOCATION_CUSTOMER_BY_TEAM_SALE,
      variables: VARIABLES_GET_LOCATION_CUSTOMER_BY_TEAM_SALE(filter),
    });
  },

  getStatusSalePlanning: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: QUERY_GET_STATUS_SALE_PLANNING,
      variables: VARIABLES_GET_STATUS_SALE_PLANNING('107'),
    });
  },
};
